import Vue from 'vue'
const vm = new Vue()
let str=location.href;
let devURL = "lianyirong";//开发域名关键字
let uatURL = "qhhrly";//测试域名关键字
let prdURL = "llschain";//生产域名关键字
let demoURL = "hrlyit";//演示环境
let sysUrl = ''
//判断用户权限中心地址需要用到什么域名
if(str.indexOf(devURL) > -1){
    sysUrl = 'https://sys-web.lianyirong.com.cn' //开发环境

}else if(str.indexOf(uatURL) > -1){
    sysUrl = 'https://sys-web.qhhrly.cn'; //测试环境

}else if((str.indexOf(prdURL) > -1)){
    sysUrl = 'https://sys-web.llschain.com'; //生产环境

}else if((str.indexOf(demoURL) > -1)){
    sysUrl = 'https://sys-web.hrlyit.com'; //演示环境

}else{
    sysUrl = 'https://sys-web.lianyirong.com.cn'; //开发环境
    // sysUrl = 'https://sys-web.qhhrly.cn'; //测试环境
}
let systemCode = 'fms' //用户权限中心对应的系统编码
const system = {}
/**
 * 查询用户菜单列表
 *  @param { 系统编码 } systemCode
 */
system.getUserMenuList = function(that,id) {
    let url = ''
    console.log(that.$store.state.isSYS,'======是否启用SYS服务==========');
    if(that.$store.state.isSYS){
        url = `${sysUrl}/agw-web/sys/menu/listMenuResourceByUserId?systemCode=${systemCode}`
    }else {
        url = `/agw-web/sys/perm/getUserMenuPermList?userId=${id}`
    }

    return vm.$http.post(url)
}
/**
 * 查询所有枚举接口
 */
system.getSysDict = function() {
    let url = `/kj-web/dict/getAllDictList`
    return vm.$http.post(url)
}
system.listMarketplaceRegion = function(data) {
    let url = `/kj-bigdata/enterpriseAccess/listMarketplaceRegion`
    return vm.$http.post(url, data)
}

// 添加授权店铺
system.bindEnterpriseAccess = function(data) {
    let url = `/kj-bigdata/enterpriseAccess/bindEnterpriseAccess`
    return vm.$http.post(url, data)
}

// 查询授权店铺
system.pageAuthorizedStores = function(params) {
    let url = `/kj-bigdata/enterpriseAccess/pageAuthorizedStores`
    return vm.$http.get(url, {params})
}


// 查询授权状态
system.queryAccessStatus = function(params) {
    let url = `/kj-bigdata/enterpriseAccess/queryAccessStatus`
    return vm.$http.get(url, {params})
}
// 上传文件
system.batchUpload = function(data) {
    let url = `/kj-bigdata/batchUploadFile/internalFile/batchUpload`
    return vm.$http.post(url, data)
}
// 公共枚举
system.queryList = function(data) {
    let url = `/kj-tools/enumType/queryList`
    return vm.$http.post(url, data)
}
// 新增企业信息
system.updateByEnterpriseId = function(data) {
    let url = `/kj-kyc/kjEnterpriseSalesRel/updateByEnterpriseId`
    return vm.$http.post(url, data)
}
// 查询企业信息
system.getCorpInfo = function(query) {
    let url = `/kj-kyc/kjEnterpriseSalesRel/getCorpInfo`
    return vm.$http.get(url, query)
}

system.getTokenByEnterpriseId = function() {
    let url = `/kj-bigdata/clientAuthInfo/getTokenByEnterpriseId`
    return vm.$http.get(url)
}

system.getWebsiteUrl = function(data) {
    let url = `/kj-tools/configuration/website`
    return vm.$http.post(url, data)
}

// 铃铛消息数据 查询接口
system.getNotificationcount = function(params) {
    // let url = `/kj-tools/notification/count`
    let url = `/kj-tools/message/notification/count`
    return vm.$http.get(url, {params})
}

// 消息列表 查询接口 - 右侧抽屉列表
system.queryNotificationList = function(data) {
    let url = `/kj-tools/notification/query`
    return vm.$http.post(url, data)
}

// PUSH 未读消息列表 查询接口
system.getPushlistUndeal = function(params) {
    let url = `/kj-tools/notification/listUndeal`
    return vm.$http.get(url, {params})
}

// 更新消息状态
system.updateHandleStatus = function(data) {
    let url = `/kj-tools/notification/updateHandleStatus`
    return vm.$http.post(url, data)
}

// 标记任务已下载
system.markDownloaded = function(data) {
    let url = `/kj-tools/kjLedgerDownloadInfo/mark/downloaded`
    return vm.$http.post(url, data)
}

// DTT 获取token地址
system.getTokenUrl = function(params) {
    let url = `/kj-kyc/eKyc/getTokenUrl`
    return vm.$http.get(url, {params})
}
// 判断顶部公告是否展示
system.getTopNoticeShow = function() {
    let url = `/kj-sys/user/whetherShowNotice`
    return vm.$http.post(url)
}
// 关闭顶部公告通知
system.closeTopNotice = function() {
    let url = `/kj-sys/user/notice/close`
    return vm.$http.post(url)
}

system.getCity = function(){
    let url = `/kj-kyc/zhongdengRegion/listCities`
    return vm.$http.get(url)
}
system.getProvince = function(){
    let url = `/kj-kyc/zhongdengRegion/listProvinces`
    return vm.$http.get(url)
}
// 查询CFCA协议
system.queryCfcaAgreement = function() {
    let url = `/kj-kyc/contractInfo/getUnsignedCfca`
    return vm.$http.post(url)
}
// 签署CFCA协议
system.signCfcaAgreement = function(data) {
    let url = `/kj-kyc/contractInfo/signCfca`
    return vm.$http.post(url, data)
}
// https://cbf-ops.hrlyit.com/kj-bigdata/clientAuthInfo/getTokenByEnterpriseId
export default system
